import { render, staticRenderFns } from "./popUpRenameGroup.vue?vue&type=template&id=8d674580&scoped=true"
import script from "./popUpRenameGroup.vue?vue&type=script&lang=js"
export * from "./popUpRenameGroup.vue?vue&type=script&lang=js"
import style0 from "./popUpRenameGroup.vue?vue&type=style&index=0&id=8d674580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d674580",
  null
  
)

export default component.exports